/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class Helper {
    public headerHeight: string = '0px'
    public color: any = {
        wellness: getComputedStyle(document.documentElement).getPropertyValue('--color-orange').trim() as string,
        medicine: getComputedStyle(document.documentElement).getPropertyValue('--color-blue').trim() as string,
        rehabilitation: getComputedStyle(document.documentElement).getPropertyValue('--color-purple').trim() as string,
        experience: getComputedStyle(document.documentElement).getPropertyValue('--color-darkgreen').trim() as string,
    }

    private breakpoint = {
        xs: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xs').trim()) as number,
        sm: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm').trim()) as number,
        md: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md').trim()) as number,
        lg: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg').trim()) as number,
        xl: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl').trim()) as number,
        xxl: parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xxl').trim()) as number,
        current: '',
    }

    public transitionTime = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--transition-time')) as number

    constructor() {
        this.setCurrentBreakpoint()
        this.setHeaderHeight()
    }

    /**
     * Get current breakpoint
     */
    public setCurrentBreakpoint(): void {
        const viewportWidth = window.innerWidth
        const breakpoints = this.breakpoint
        let currentBreakpoint

        Object.keys(breakpoints).forEach((key) => {
            if (breakpoints[key] <= viewportWidth) {
            currentBreakpoint = key
            }
        })

        // console.log(currentBreakpoint)
        this.breakpoint.current = currentBreakpoint
    }

    public getCurrentBreakpoint(): string {
        this.setCurrentBreakpoint()
        return this.breakpoint.current
    }

    private setHeaderHeight(): void {
        const rootEl = document.querySelector(':root') as HTMLElement | null
        const headerEl = document.querySelector('.header') as HTMLElement | null
        const headerHeight: number = headerEl?.offsetHeight - 1 ?? 0
        rootEl?.style.setProperty('--header-height', `${String(headerHeight)}px`)
        this.headerHeight = `${String(headerHeight)}px`
    }
}

/**
 *     @section 3. Export class
 */

export default new Helper()

// enf of app--helper.ts file
